module.exports = __webpack_public_path__ + "static/media/alarm-clock.2803116d.ttf";